"use client";

import React from "react";
import { IconSelector } from "@tabler/icons-react";

interface TriggerCardProps extends React.HTMLAttributes<HTMLDivElement> {
  icon: React.ReactNode;
  label: string;
  isValid: boolean;
  children: React.ReactNode;
  className?: string;
  isObrigatorio?: boolean; // Quando true, aplica estilo vermelho para indicar obrigatoriedade
}

export function TriggerCard({
  icon,
  label,
  isValid,
  children,
  className = "",
  isObrigatorio = false,
  ...props
}: TriggerCardProps) {
  // Estilo vermelho quando obrigatório e não válido
  const isRequiredStyle = isObrigatorio && !isValid;
  
  const bgGradient = isRequiredStyle
    ? "from-red-50 to-red-100 dark:from-red-950/30 dark:to-red-900/20"
    : "from-cyan-50 to-cyan-100 dark:from-cyan-950/30 dark:to-cyan-900/20";
  
  const borderColor = isRequiredStyle
    ? "border-red-300 dark:border-red-700"
    : "border-cyan-200 dark:border-cyan-800";

  return (
    <div
      className={`w-full h-full rounded-lg flex flex-col p-3 border bg-gradient-to-br cursor-pointer transition-all hover:scale-[1.02] ${bgGradient} ${borderColor} ${className}`}
      {...props}
    >
      {/* Header com ícone e status */}
      <div className="flex items-center justify-between mb-2">
        <div className="flex items-center gap-2">
          {icon}
          <div className="flex items-center gap-2">
            <span className={`text-xs font-medium ${isRequiredStyle ? "text-red-700 dark:text-red-300" : ""}`}>
              {label}
              {isObrigatorio && !isValid && (
                <span className="ml-1 text-red-600 dark:text-red-400">*</span>
              )}
            </span>
            <div
              className={`w-2 h-2 rounded-full ${
                isValid ? "bg-green-500" : isRequiredStyle ? "bg-red-500" : "bg-amber-400"
              }`}
            />
          </div>
        </div>
        <IconSelector className="size-4 opacity-50" />
      </div>

      {/* Conteúdo principal */}
      <div className="space-y-1 flex-1 flex flex-col justify-center">
        {children}
      </div>
    </div>
  );
}
